import api from './api'

function list(params = {}) {
  return api.get('/admin/filiations', { params })
}

function show(id) {
  return api.get(`/admin/filiations/${id}`)
}

function update(id, body) {
  return api.put(`/admin/filiations/${id}`, body)
}

function resume(id, params = {}) {
  return api.get(`/admin/filiations/${id}/resume`, { params })
}

function filiationPurchases(id, params = {}) {
  return api.get(`/admin/filiations/${id}/filiation-purchases`, { params })
}

function filiationSubscriptions(id, params = {}) {
  return api.get(`/admin/filiations/${id}/filiation-subscriptions`, { params })
}

function activate(id) {
  return api.post(`/admin/filiations/${id}/activate`)
}

function deactivate(id) {
  return api.delete(`/admin/filiations/${id}/deactivate`)
}

function balance(id, params) {
  return api.get(`/admin/filiations/${id}/balance`, { params })
}

export default {
  list,
  show,
  update,
  resume,
  filiationPurchases,
  filiationSubscriptions,
  activate,
  deactivate,
  balance,
}
